<template>
  
  <main-layout v-if="this.$route.meta.layout === 'MainLayout'">
    <!--vue-router -->
    <router-view></router-view>
  </main-layout>

  <SimpleLayout v-else>
    <!--vue-router -->
    <router-view></router-view>
  </SimpleLayout>
</template>

<script>

import MainLayout from "@/layout/MainLayout.vue"
import SimpleLayout from "@/layout/SimpleLayout.vue"

export default{

  components:{
    MainLayout,
    SimpleLayout
  }

}
</script>

<style>

</style>
